module.exports = __webpack_public_path__ + "img/环境维护巡检@3x.06810e40.png";